import Instance from "../../../../Axios";

// New Actions for the app

const GetOrcamentosAdjudicadosValor =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/orcamentosAdjudicadosValor`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_ORCAMENTOS_ADJUDICADOS_VALOR",
          payload: data.yData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetOrcamentosAdjudicadosValor;
